/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Module for Custom Rep/Covering Cell.
 * @module src/Events/EventsList
 */
/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';

interface Quantity {
  quantity: string;
  availablequantity: string;
  productdescription: string;
  id: string;
  createdByDetails: [];
  isOpen: boolean;
  needToDisplay: boolean;
  availableQuantity?: string;
  expectedQty?: number;
}
interface Props {
  item?: Quantity;
  property?: string;
}
const defaultItem: Quantity = {
  quantity: '',
  availablequantity: '',
  productdescription: '',
  createdByDetails: [],
  id: '',
  isOpen: false,
  needToDisplay: false,
  availableQuantity: '',
  expectedQty: 0
};
const TableRowCell: FC<Props> = ({
  item = defaultItem, property = ''
}) => {
  const { createdByDetails, isOpen, needToDisplay } = item;
  const expectedQtyValue = property === 'expectedQty' ? item.expectedQty : property === 'availableQuantity' ? item.availableQuantity : item.availablequantity;

  return needToDisplay ? (
    <DataTableCell title={String(expectedQtyValue ?? '')} className="center-align">
      {expectedQtyValue}
      {isOpen &&
        createdByDetails?.map((lineItem: any) => (
          <div className="border-line">
            <DataTableCell>{lineItem.createdByName}</DataTableCell>
          </div>
        ))}
    </DataTableCell>
  ) : null;
};

/** Custom Rep/Covering cell */
export default TableRowCell;
